export default __webpack_public_path__ + "static/media/help_main-photo_ng3.5c6aa742.jpg";